import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NotificationsInnerComponent } from './dropdown-inner/notifications-inner/notifications-inner.component';
import { UserInnerComponent } from './dropdown-inner/user-inner/user-inner.component';
import { LayoutScrollTopComponent } from './scroll-top/scroll-top.component';
import { NotificationsInnerSearchPipe } from './dropdown-inner/notifications-inner/notifications-inner-search.pipe';
import { FormsModule } from '@angular/forms';
import { InitialsModule } from 'src/app/shared/components/initials/initials.module';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    NotificationsInnerComponent,
    NotificationsInnerSearchPipe,
    UserInnerComponent,
    LayoutScrollTopComponent,
  ],
  imports: [
    CommonModule,
    InlineSVGModule,
    RouterModule,
    TranslateModule,
    FormsModule,
    InitialsModule,
    NgbDropdownModule,
  ],
  exports: [
    NotificationsInnerComponent,
    UserInnerComponent,
    LayoutScrollTopComponent,
  ],
})
export class ExtrasModule {}
